// Условия списка ключей агента в адресе страницы (005, T033; README «Табеля», «Плотные таблицы»):
// поиск по названию ключа и пользователю, фильтр «Состояние». Ключей немного — список приходит
// целиком (agentKeys.list), условия применяет страница.
import { agentKeyStates } from '@kp/contracts';
import type { AgentKey, AgentKeyState } from '@kp/contracts';

export interface AgentKeysSearch {
  q?: string;
  state?: AgentKeyState;
}

export const AGENT_KEYS_SEARCH_MAX = 200;

/** Для адреса страницы: validateSearch маршрута /agent-keys. */
export function parseAgentKeysSearch(search: Record<string, unknown>): AgentKeysSearch {
  const result: AgentKeysSearch = {};
  const q = typeof search.q === 'number' ? String(search.q) : search.q;
  if (typeof q === 'string' && q.trim() !== '' && q.length <= AGENT_KEYS_SEARCH_MAX) result.q = q;
  if (
    typeof search.state === 'string' &&
    (agentKeyStates as readonly string[]).includes(search.state)
  ) {
    result.state = search.state as AgentKeyState;
  }
  return result;
}

/** Условия сужают список: «Ничего не найдено» вместо «Ключей пока нет». */
export function hasAgentKeyFilters(search: AgentKeysSearch): boolean {
  return Boolean(search.q?.trim() || search.state);
}

/** Ё и е, регистр — не различаются. */
function fold(text: string): string {
  return text.toLocaleLowerCase('ru-RU').replaceAll('ё', 'е');
}

/** Ключи по условиям: часть названия или ФИО пользователя, состояние. */
export function filterAgentKeys(keys: readonly AgentKey[], search: AgentKeysSearch): AgentKey[] {
  const needle = fold(search.q?.trim() ?? '');
  return keys.filter(
    (key) =>
      (!search.state || key.state === search.state) &&
      (!needle || fold(key.name).includes(needle) || fold(key.user.fullName).includes(needle)),
  );
}
